import styled from 'styled-components';
import JourneyInfoSide from './JourneyInfoSide';
import { colorSchema } from 'utils/style';

export default styled(JourneyInfoSide)`
  .journey-info-side {
    border-bottom: 1px solid ${colorSchema('grey200')};
    display: block;
    padding-bottom: 2.4rem;

    &__header {
      display: flex;
      justify-content: space-between;
      padding: 2rem 0;
    }

    &__date {
      color: ${colorSchema('grey900')};
      font-size: 1.8rem;
      font-weight: bold;
      text-transform: capitalize;
    }

    &__id {
      color: ${colorSchema('grey900')};
      font-size: 1.8rem;
      font-weight: normal;
    }
  }
`;
